import UIEffectsCache from 'store/UIEffectsCache';

const useUIEffectsCache = UIEffectsCache();

export default useUIEffectsCache;
